"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmissionStatusTable = void 0;
const throttle_1 = __importDefault(require("lodash/throttle"));
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const Colors_1 = require("../../../../../Colors");
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
const common_1 = require("../../../../../common");
const server_1 = require("../../../../../server");
const DeletePopUpLayout_1 = require("../../../../base/layout/DeletePopUpLayout");
const popup_1 = require("../../../../base/popup");
const DSTL001_Submit_Detail_1 = require("../../DSTL001_Submit_Detail");
const DSTL001_Submit_View_1 = require("../../DSTL001_Submit_View");
const DSTL001DetailStyled_1 = require("./DSTL001DetailStyled");
const ScoreReportPdf_1 = require("./ScoreReportPdf");
const ScoreReportViewer_1 = require("./ScoreReportViewer");
// 제출 현황 테이블
exports.SubmissionStatusTable = react_1.default.memo(({ isTest, isSurvey = false, type, test_id, subjectId, allQuestionCount, isDetail = false, isPopUp = false, gradeReport = false, hasReport = false, reportSubjectLabel, reportTestDate, reportType, handlerUpdateMember, reportName, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isMobile, isTablet, isDesktop, classesId } = (0, GlobalStateProvider_1.useGlobalState)();
    const [page, setPage] = (0, react_1.useState)(0);
    const [count, setCount] = (0, react_1.useState)(10);
    const [testData, setTestData] = (0, react_1.useState)([]);
    const [totalCount, setTotalCount] = (0, react_1.useState)(0);
    const [questionCount, setQuestioncount] = (0, react_1.useState)(0);
    const [submissionStatus, setSubmissionStatus] = (0, react_1.useState)();
    const [statusFilter, setStatusFilter] = (0, react_1.useState)({
        id: 'all',
        title: t('common.all'),
    });
    const [orderOption, setOrderOption] = (0, react_1.useState)();
    const [searchOption, setSearchOption] = (0, react_1.useState)();
    const [totalSubmitted, setTotalSubmitted] = (0, react_1.useState)(0);
    const [selected, setSelected] = (0, react_1.useState)();
    // 탭(선택과목) 전환 시 응시자 목록 페이지네이션을 1페이지로 초기화한다.
    // '전체' 탭에서 뒤쪽 페이지를 보던 상태로 과목 탭을 바꾸면 offset(page*count)이 그대로
    // 유지돼, 해당 과목의 목록 범위를 넘어서면서 빈 화면('제출 내역 없음')으로 보였다.
    // 렌더 중 보정(React 권장 패턴)인 이유: useEffect 로 미루면 이 커밋의 조회 effect 가
    // 아직 이전 offset 으로 한 번 더 조회해(keepPreviousData 로) 빈 목록이 잠깐 스치기 때문.
    const [prevSubjectId, setPrevSubjectId] = (0, react_1.useState)(subjectId);
    if (prevSubjectId !== subjectId) {
        setPrevSubjectId(subjectId);
        setPage(0);
    }
    const isSubjectiveType = type === '설문형' || type === '파일첨부형';
    const isOmrType = type === 'OMR (기본형)' || type === 'OMR (자유형)';
    const submittedStatusText = isOmrType ? t('assignment.stare') : t('assignment.submitted');
    const notSubmittedStatusText = isOmrType ? t('assignment.noStare') : t('assignment.notSubmitted');
    const detailColumnTitle = isSubjectiveType ? 'submissionInfo' : 'testPaper';
    const { headTitleList, tableReadDataKeys } = react_1.default.useMemo(() => {
        const shouldShowPaperColumns = isDetail && isDesktop;
        const shouldShowReportCard = shouldShowPaperColumns && hasReport;
        const isTeacherDesktopDetail = isDetail && isDesktop;
        const headTitleList = isTeacherDesktopDetail
            ? [
                { title: 'name', space: 1, sort: false },
                { title: 'student_id', space: 1, sort: false },
                { title: isTest ? 'exam_status' : 'live_status', space: 1, sort: false },
                ...(isSubjectiveType
                    ? [{ title: 'question', space: 1, sort: false }]
                    : [
                        { title: 'correctNumber', space: 1, sort: false },
                        { title: 'grades', space: 1, sort: false },
                    ]),
                ...(shouldShowPaperColumns
                    ? [
                        { title: detailColumnTitle, space: 1, sort: false },
                        ...(shouldShowReportCard
                            ? [{ title: 'reportCard', space: 1, sort: false }]
                            : []),
                    ]
                    : [{ title: 'etc', space: 1, sort: false }]),
            ]
            : [
                ...(isMobile
                    ? [
                        { title: isTest ? 'exam_status' : 'live_status', space: 2, sort: false },
                        { title: 'nameId', space: 1, sort: false },
                    ]
                    : [
                        { title: 'nameId', space: 3, sort: false },
                        { title: isTest ? 'exam_status' : 'live_status', space: 1, sort: false },
                    ]),
                ...(isSubjectiveType
                    ? [{ title: 'question', space: 2, sort: false }]
                    : [
                        { title: 'correctNumber', space: 2, sort: false },
                        { title: 'grades', space: 1, sort: false },
                    ]),
                ...(shouldShowPaperColumns
                    ? [
                        { title: detailColumnTitle, space: 1, sort: false },
                        ...(shouldShowReportCard
                            ? [{ title: 'reportCard', space: 1, sort: false }]
                            : []),
                    ]
                    : [{ title: 'etc', space: 1, sort: false }]),
            ];
        const tableReadDataKeys = isTeacherDesktopDetail
            ? [
                { title: 'member_name', space: 1, sort: false },
                { title: 'member_idf', space: 1, sort: false },
                { title: 'status', space: 1, sort: false },
                ...(isSubjectiveType
                    ? [{ title: 'question', space: 1, sort: false }]
                    : [
                        { title: 'answer', space: 1, sort: false },
                        { title: 'score', space: 1, sort: false },
                    ]),
                ...(shouldShowPaperColumns
                    ? [
                        { title: detailColumnTitle, space: 1, sort: false },
                        ...(shouldShowReportCard
                            ? [{ title: 'reportCard', space: 1, sort: false }]
                            : []),
                    ]
                    : [{ title: 'etc', space: 1 }]),
            ]
            : [
                ...(isMobile
                    ? [
                        { title: 'status', space: 2, sort: false },
                        { title: 'member_name', space: 1, sort: false },
                    ]
                    : [
                        { title: 'member_name', space: 3, sort: false },
                        { title: 'status', space: 1, sort: false },
                    ]),
                ...(isSubjectiveType
                    ? [{ title: 'question', space: 2, sort: false }]
                    : [
                        { title: 'answer', space: 2, sort: false },
                        { title: 'score', space: 1, sort: false },
                    ]),
                ...(shouldShowPaperColumns
                    ? [
                        { title: detailColumnTitle, space: 1, sort: false },
                        ...(shouldShowReportCard
                            ? [{ title: 'reportCard', space: 1, sort: false }]
                            : []),
                    ]
                    : [{ title: 'etc', space: 1 }]),
            ];
        // useMemo에서 반환
        return { headTitleList, tableReadDataKeys };
    }, [detailColumnTitle, isMobile, isDetail, isDesktop, gradeReport]);
    // 선택과목 필터 시 해당 과목의 submit-status 응답(목록·정답수·점수)을 그대로 표시한다.
    // (배열[공통,선택]은 공통이 전원과 매칭돼 목록이 전체가 되므로 단일 subject_item 사용)
    const { data, refetch } = (0, server_1.useSubmitStatus)({
        id: test_id,
        subject_item: subjectId,
        offset: page === 0 ? 0 : page * count,
        limit: count,
        // 제출/미응시 필터는 서버 측에서 적용(submitted=true/false). 전체는 미전송.
        // (클라 페이지만 거르면 로드된 페이지의 일부만 보이는 문제 방지)
        // p.45: 선택과목 탭(subjectId 존재) 적용 시에는 미응시자 비노출(submitted=true).
        //        단 사용자가 응시상태 필터를 명시 선택하면 그 값을 우선. 전체 탭은 기존대로 전원 노출.
        ...(statusFilter.id !== 'all'
            ? { submitted: statusFilter.id === 'submitted' }
            : subjectId
                ? { submitted: true }
                : {}),
        // ...(orderOption ? { orderby: orderOption } : {}),
        ...(searchOption ? { ...searchOption } : {}),
    });
    (0, react_1.useEffect)(() => {
        test_id && refetch();
    }, [test_id, subjectId, searchOption, orderOption, statusFilter.id]);
    (0, react_1.useEffect)(() => {
        if (!data)
            return;
        const { not_submitted, submitted, question_count, items, total_count } = data;
        // 선택 과목 필터의 submit-status 응답(목록·정답수·점수)을 클라 가공 없이 그대로 표시
        setTestData(items);
        setTotalCount(total_count);
        // 분모(총 문항수)는 동일 필터의 /statistics 기준값(allQuestionCount) 우선, 없으면 응답값
        setQuestioncount(allQuestionCount || question_count);
        setTotalSubmitted(submitted);
        setSubmissionStatus(`${submitted}/${total_count}`);
    }, [data, allQuestionCount]);
    const statusFilterList = [
        { id: 'all', title: t('common.all') },
        { id: 'submitted', title: submittedStatusText },
        { id: 'not_submitted', title: notSubmittedStatusText },
    ];
    const filteredTestData = react_1.default.useMemo(() => {
        if (statusFilter.id === 'submitted') {
            return testData.filter(member => !member.not_submitted);
        }
        if (statusFilter.id === 'not_submitted') {
            return testData.filter(member => member.not_submitted);
        }
        return testData;
    }, [testData, statusFilter.id]);
    // 페이지네이션 분모는 '실제 조회 조건'과 일치해야 한다.
    // 선택과목 탭(subjectId)은 응시상태 필터가 '전체'여도 조회에 submitted=true 가 적용되므로
    // (위 useSubmitStatus 참조) 분모도 해당 과목 제출 인원(response.submitted)이어야 한다.
    // 서버 total_count 는 과목과 무관한 '대상 인원'이라 그대로 쓰면 목록이 2명인데
    // 페이지 버튼이 여러 개 나오는 문제가 생긴다.
    const pagingTotalCount = (0, react_1.useMemo)(() => {
        const base = statusFilter.id === 'submitted'
            ? totalSubmitted
            : statusFilter.id === 'not_submitted'
                ? Math.max(0, totalCount - totalSubmitted)
                : subjectId
                    ? totalSubmitted
                    : totalCount;
        // 하한 보정: 분모가 이미 불러온 행 수(offset + 현재 페이지 행 수)보다 작아지면 실제
        // 존재하는 페이지가 감춰져 뒤쪽 응시자에 접근할 수 없다. 집계값이 어긋나도 목록에
        // 보이는 만큼은 항상 페이징 대상으로 남긴다.
        return Math.max(base, page * count + testData.length);
    }, [statusFilter.id, subjectId, totalCount, totalSubmitted, page, count, testData.length]);
    const handlerMoreData = (page) => {
        setPage(page);
    };
    // (리스트 갱신
    const refetchList = (0, throttle_1.default)(() => {
        refetch();
    }, 1000, { leading: true, trailing: false });
    (0, react_1.useEffect)(() => {
        setCount(10);
        refetchList();
    }, [isTest, count, page, searchOption, refetch]);
    const openAssignment = (member) => {
        if (isMobile) {
            localStorage.setItem('rememberTabIndex', JSON.stringify(2));
            if (subjectId)
                localStorage.setItem('rememberSubjectId', JSON.stringify(subjectId));
            APP.eventManager.publish('UPDATE_DETAIL_MENU', {
                menuDetail: 'submit_view',
                id: test_id,
                props: {
                    member,
                    subjectId,
                },
            });
        }
        else {
            APP.eventManager.publish(popup_1.TOGGLE_POPUP, {
                component: DSTL001_Submit_View_1.DSTL001_Submit_View,
                componentProps: {
                    test_id,
                    member,
                    subjectId,
                    isSurvey,
                    handlerClose: () => {
                        APP.eventManager.publish('RESET_SUBJECT');
                    },
                },
                width: 757,
                title: isTest
                    ? t('assignment.showTest')
                    : isSurvey
                        ? t('assignment.showSurvey')
                        : t('assignment.show'),
            });
        }
    };
    const openAssignmentDetail = () => {
        if (isMobile) {
            localStorage.setItem('rememberTabIndex', JSON.stringify(2));
            if (subjectId)
                localStorage.setItem('rememberSubjectId', JSON.stringify(subjectId));
            APP.eventManager.publish('UPDATE_DETAIL_MENU', {
                menuDetail: 'submit_detail_view',
                id: test_id,
                props: {
                    subjectId,
                    isDetail: false,
                    test_id,
                    member_id: '',
                    isTeacher: true,
                    isPreview: true,
                },
            });
        }
        else {
            APP.eventManager.publish(popup_1.TOGGLE_POPUP, {
                component: DSTL001_Submit_Detail_1.DSTL001_Submit_Detail,
                componentProps: { test_id, isTest, isPreview: false, subjectId, isSurvey },
                width: 1377,
                title: t(`assignment.${isTest ? 'showTestDetail' : 'showDetail'}`),
            });
        }
    };
    const handlerFilterList = (filter) => {
        // 검색 조건 변경 시에도 페이지네이션을 1페이지로 초기화한다 — 뒤쪽 페이지에서 검색하면
        // offset(page*count)이 유지돼 결과가 있어도 빈 화면('제출 내역 없음')이 되던 문제.
        // (응시상태 필터 드롭다운도 동일하게 setPage(0) 후 값을 바꾼다)
        setPage(0);
        setSearchOption(filter);
    };
    const handlerUpdateList = (sort, desc) => {
        const newSort = sort === 'nameId'
            ? 'member_name'
            : sort === 'live_status'
                ? 'status'
                : sort === 'correctNumber'
                    ? 'number'
                    : sort === 'grades'
                        ? 'score'
                        : sort;
        setOrderOption([`${newSort} ${desc ? 'DESC' : 'ASC'}`]);
    };
    const handlerShow = (id) => {
        setSelected(selected === id ? undefined : id);
    };
    const showErrorPopup = (message) => {
        APP.eventManager.publish(popup_1.TOGGLE_POPUP, {
            component: DeletePopUpLayout_1.DeletePopUpLayout,
            componentProps: {
                deleteContent: [message],
                showCancel: false,
            },
            width: 500,
            isFit: true,
            title: t('common.viewReportCard'),
        });
    };
    const buildReportPayload = async (member) => {
        if (!hasReport) {
            showErrorPopup(t('assignment.reportCardUnavailable'));
            return null;
        }
        await APP.eventManager.publish('SHOW_LOADING', true);
        try {
            const [reportResponse, cutoffResponse, gradeResponse] = await Promise.all([
                (0, server_1.getReportData)({
                    id: test_id,
                    queryString: `member_id=${encodeURIComponent(member.member_id)}`,
                }),
                (0, server_1.getTierCutoff)(test_id, member.member_id),
                // ref_test_id: 현재 테스트와 같은 성적표(상세) 유형의 회차만 조회 — 기타(etc)에서 상세유형(홍모/K+ 등)이 섞이지 않도록.
                (0, server_1.getGradeReport)({
                    id: member.member_id,
                    queryString: `class_id=${encodeURIComponent(classesId)}&report_type=${encodeURIComponent(reportType ?? '')}&ref_test_id=${encodeURIComponent(test_id)}`,
                }),
            ]);
            // 같은 회차 재응시는 'N회차(재)' — ref_test_id 조회 결과 + 안정 정렬(같은 회차는 서버 순서=시간 순 유지) 전제
            const sortedGradeReport = (0, server_1.markRetakeRounds)((gradeResponse.result.items || []).slice().sort((a, b) => (a.round ?? 0) - (b.round ?? 0)));
            return {
                report: reportResponse.result,
                tierCutoffs: cutoffResponse.result.items || [],
                gradeReport: sortedGradeReport,
                subjectLabel: reportSubjectLabel,
                testDate: reportTestDate,
                reportType,
                showGradeReport: gradeReport,
                reportName: reportName,
            };
        }
        catch (error) {
            showErrorPopup(typeof error === 'string' ? error : t('assignment.reportCardLoadFailed'));
            return null;
        }
        finally {
            await APP.eventManager.publish('SHOW_LOADING', false);
        }
    };
    const openReportCard = async (member) => {
        const payload = await buildReportPayload(member);
        if (!payload)
            return;
        try {
            const pdfData = await (0, ScoreReportPdf_1.openScoreReportPdf)(payload);
            const testName = payload.report.test_name || '';
            const memberName = member.member_name || '';
            const baseName = [testName, memberName].filter(Boolean).join(' - ') + ' 성적표';
            const filename = `${baseName}.pdf`;
            APP.eventManager.publish(popup_1.TOGGLE_POPUP, {
                component: ScoreReportViewer_1.ScoreReportViewer,
                componentProps: {
                    pdfData,
                    filename,
                    title: baseName,
                    onDownload: () => (0, ScoreReportPdf_1.downloadScoreReportPdf)(payload, filename),
                },
                title: t('common.viewReportCard'),
            });
        }
        catch (error) {
            showErrorPopup(error instanceof Error ? error.message : t('assignment.reportCardLoadFailed'));
        }
    };
    const downloadReportCard = async (member) => {
        const payload = await buildReportPayload(member);
        if (!payload)
            return;
        try {
            const testName = payload.report.test_name || '';
            const memberName = member.member_name || '';
            const filename = `${[testName, memberName].filter(Boolean).join(' - ')} 성적표.pdf`;
            await (0, ScoreReportPdf_1.downloadScoreReportPdf)(payload, filename);
        }
        catch (error) {
            showErrorPopup(error instanceof Error ? error.message : t('assignment.reportCardLoadFailed'));
        }
    };
    const isTeacherDesktopDetail = isDetail && isDesktop;
    const teacherDesktopTableStyles = (0, react_1.useMemo)(() => isTeacherDesktopDetail
        ? {
            headItem: {
                justifyContent: 'center',
            },
            bodyItem: {
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
            },
        }
        : undefined, [isTeacherDesktopDetail]);
    //데스트탑, 모바일 bodyItem
    const renderItem = (item, styles) => {
        if (!isDesktop) {
            const scoreText = item.score === -1 ? '-' : item.score;
            const correctText = item.corrects === -1 ? '-' : item.corrects;
            const mobileSummaryText = isOmrType
                ? `${t('table.answer')} ${correctText}/${questionCount} · ${t('table.grades')} ${scoreText}점`
                : '';
            return (react_1.default.createElement("div", { key: `mobile-${item.member_id}`, className: `body-item mobile-detail-item ${isTablet ? 'tablet-row' : ''}`, style: { ...styles?.bodyItem, overflow: 'visible' } },
                react_1.default.createElement("div", { className: "mobile-detail-info" },
                    react_1.default.createElement("div", { className: "mobile-detail-header" },
                        react_1.default.createElement("div", { className: "mobile-status-chip-wrap" },
                            react_1.default.createElement("p", { className: `mobile-status-chip ${item.not_submitted ? 'not-submitted' : ''}` }, item.not_submitted ? notSubmittedStatusText : submittedStatusText)),
                        react_1.default.createElement("p", { className: "mobile-member-name" },
                            react_1.default.createElement("span", { className: "mobile-member-name-strong" }, item.member_name),
                            ' ',
                            "(",
                            item.member_idf,
                            ")")),
                    isOmrType && (react_1.default.createElement("p", { className: "mobile-score-line", style: styles?.bodyText }, mobileSummaryText))),
                react_1.default.createElement("div", { className: "mobile-action-row" },
                    react_1.default.createElement(common_1.Button, { className: "btn_default mobile-xs fit_btn mobile-action-btn", styles: { buttonWrap: { width: '100%' } }, text: isOmrType ? 'common.viewTestPaper' : 'common.detail', onClick: () => openAssignment({ id: item.member_id, name: item.member_name }) }),
                    (gradeReport && hasReport) && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(common_1.Button, { className: "btn_default mobile-xs fit_btn mobile-action-btn", styles: { buttonWrap: { width: '100%' } }, text: "common.viewReportCard", onClick: () => openReportCard(item) }),
                        react_1.default.createElement(common_1.Button, { className: "btn_default mobile-xs fit_btn mobile-action-btn", styles: { buttonWrap: { width: '100%' } }, text: "common.downloadReportCard", onClick: () => downloadReportCard(item) }))))));
        }
        return tableReadDataKeys.map(headItem => (react_1.default.createElement("div", { key: headItem.title, className: "body-item", style: {
                flex: headItem.space,
                ...styles?.bodyItem,
                overflow: 'hidden',
            } }, headItem.title === 'etc' ? (react_1.default.createElement("p", { className: isDetail
                ? selected === item.member_id
                    ? 'detail_more_txt_bold'
                    : 'detail_more_txt'
                : 'more_txt', onClick: () => {
                if (isDetail) {
                    if (handlerUpdateMember) {
                        handlerUpdateMember({
                            id: item.member_id,
                            name: item.member_name,
                        });
                    }
                    handlerShow(item.member_id);
                }
                else {
                    openAssignment({
                        id: item.member_id,
                        name: item.member_name,
                    });
                }
            } }, isDetail ? t('common.view') : t('common.detail'))) : headItem.title === 'score' ? (react_1.default.createElement("p", { className: "overText", style: styles?.bodyText }, item.score === -1 ? '-' : item.score)) : headItem.title === 'answer' ? (!isDesktop ? (react_1.default.createElement("div", { className: "score-wrap", style: { color: Colors_1.Colors.grey } },
            react_1.default.createElement("div", { className: "overText", style: styles?.bodyText },
                t('table.answer'),
                " : ",
                item.corrects === -1 ? '-' : item.corrects,
                "/",
                questionCount),
            react_1.default.createElement("div", { className: "divider" }),
            react_1.default.createElement("div", { className: "overText", style: styles?.bodyText },
                t('table.grades'),
                " : ",
                item.corrects === -1 ? '-' : item['score']))) : (react_1.default.createElement("p", { className: "overText", style: styles?.bodyText },
            item.corrects === -1 ? '-' : item.corrects,
            "/",
            questionCount))) : ['testPaper', 'submissionInfo'].includes(headItem.title) ? (item.not_submitted ? (react_1.default.createElement("p", { className: "overText", style: styles?.bodyText }, "-")) : (react_1.default.createElement("p", { className: "more_txt", onClick: () => {
                // TODO(서버연동): 시험지 조회 API가 준비되면 시험지 전용 조회 액션으로 교체
                openAssignment({
                    id: item.member_id,
                    name: item.member_name,
                });
            } }, t('common.view')))) : headItem.title === 'reportCard' ? ((item.not_submitted || !hasReport) ? (react_1.default.createElement("p", { className: "overText", style: styles?.bodyText }, "-")) : (react_1.default.createElement("div", { style: { display: 'flex', alignItems: 'center', gap: 10 } },
            react_1.default.createElement("p", { className: "more_txt", onClick: () => openReportCard(item) }, t('common.view')),
            react_1.default.createElement("p", { className: "more_txt", onClick: () => downloadReportCard(item) }, t('common.download'))))) : headItem.title === 'member_idf' ? (react_1.default.createElement("p", { className: "overText", style: styles?.bodyText }, item.member_idf)) : headItem.title === 'member_name' ? (isTeacherDesktopDetail ? (react_1.default.createElement("p", { className: "overText", style: styles?.bodyText }, item.member_name)) : (react_1.default.createElement("p", { className: "overText2 submission-name", style: styles?.bodyText }, `${item[headItem.title]}(${item.member_idf})`))) : headItem.title === 'question' ? (react_1.default.createElement("p", { className: "overText", style: styles?.bodyText }, questionCount)) : (react_1.default.createElement("p", { className: `overText ${!isDesktop && headItem.title === 'member_name' ? 'bold' : ''} ${headItem.title === 'member_name' && selected === item.member_id
                ? 'underline'
                : ''}`, style: styles?.bodyText }, headItem.title === 'status'
            ? item.not_submitted
                ? notSubmittedStatusText
                : submittedStatusText
            : headItem.title === 'score'
                ? item.corrects === -1
                    ? '-'
                    : item[headItem.title]
                : headItem.title === 'answer'
                    ? `${item.corrects === -1 ? '-' : item.corrects}/${questionCount}`
                    : item[headItem.title])))));
    };
    const renderTitle = (0, react_1.useMemo)(() => (react_1.default.createElement("div", { className: "task-label", style: {
            width: '100%',
            alignItems: 'space-between',
            fontSize: !isDesktop ? '14px' : '16px',
            gap: !isDesktop && '6px',
        } },
        react_1.default.createElement("p", null, isTest
            ? t('assignment.examineeMemberList')
            : `${t('assignment.submissionStatus', {
                submissionStatus: submissionStatus || '',
            })} ${subjectId ? `- ${subjectId}` : ''}`),
        isDetail ? (react_1.default.createElement("div", { style: { display: 'flex', alignItems: 'center', gap: 8 } },
            react_1.default.createElement(common_1.DropDown, { className: `dropdown-${isMobile ? 'mobile-small' : 'small'}`, fixedList: isMobile || isTablet, value: statusFilter, list: statusFilterList, setDropValue: (v) => {
                    setPage(0);
                    setStatusFilter(v);
                }, styles: {
                    dropWrap: {
                        width: isMobile ? 120 : 114,
                    },
                } }),
            react_1.default.createElement(common_1.SearchBar, { className: `${!isMobile ? 'search-bar-qna' : 'search-bar-mobile'}`, filterData: "member_name", handlerFilterList: handlerFilterList }))) : (react_1.default.createElement("p", { className: "detail_txt", onClick: openAssignmentDetail }, t('common.detail'))))), [subjectId, handlerFilterList, submissionStatus, statusFilter.id]);
    const renderEmpty = (0, react_1.useMemo)(() => (react_1.default.createElement("div", { className: "empty_data", style: { color: Colors_1.Colors.light_grey } }, t(`assignment.noSubmit`))), []);
    return (react_1.default.createElement(DSTL001DetailStyled_1.DSTL001DetailTableStyled, { "$isMobile": isMobile, "$isTablet": isTablet, "$isDetail": isDetail, className: `field-global-001 ${isPopUp ? 'popup-table' : ''}`, style: { flexDirection: 'column', overflow: isDesktop && !isPopUp && 'auto' } },
        react_1.default.createElement(common_1.Table, { className: "task-list-002", showIndex: !isDesktop && isDetail ? false : true, indexOrder: "desc", isInfinite: false, page: page, data: filteredTestData, sortDefault: "member_id", showCount: count, pagingCount: 5, totalCount: pagingTotalCount, headTitleList: headTitleList, renderTitle: renderTitle, renderItem: renderItem, handlerMoreData: handlerMoreData, handlerUpdateList: handlerUpdateList, styles: teacherDesktopTableStyles, forceShowheader: (isTablet && isDetail) || isMobile ? false : true, renderEmpty: filteredTestData.length === 0 && renderEmpty, padding: false })));
});
